import { PageResponse } from '@core/entities/pagination'
import {
  ITemplateEditorChecklistTemplateVersion,
  TemplateEditorChecklistTemplateVersion,
} from '@core/entities/checklist/TemplateEditorChecklistTemplateVersion'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  checklistTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = ({
  content,
  ...response
}: PageResponse<ITemplateEditorChecklistTemplateVersion>) => {
  return {
    ...response,
    content: content.map((template) =>
      TemplateEditorChecklistTemplateVersion.new(template),
    ),
  }
}

export const useGetChecklistTemplateVersions = (
  params: RequestTypes['getChecklistTemplateVersions'],
  options?: UseQueryOptions<
    PageResponse<ITemplateEditorChecklistTemplateVersion>,
    RequestErrorType,
    PageResponse<TemplateEditorChecklistTemplateVersion>
  >,
) => {
  return useQuery<
    PageResponse<ITemplateEditorChecklistTemplateVersion>,
    RequestErrorType,
    PageResponse<TemplateEditorChecklistTemplateVersion>
  >({
    select: dataTransformer,
    ...checklistTemplateKeys.getVersions(params),
    ...options,
  })
}
